import { useQuery } from '@tanstack/react-query';
import { listModelCards } from '@/api/modelCards.api';
import { useAuthStore } from '@/store/auth.store';

export function useModelCards() {
  const user = useAuthStore((state) => state.user);
  return useQuery({
    queryKey: ['model-cards', user?.user_id],
    queryFn: ({ signal }) => listModelCards(signal),
    staleTime: 60_000,
    retry: false,
  });
}
